import React from 'react';
import PropTypes from 'prop-types';
import Button from '@concur/nui-widgets/Button';
import classnamesBind from 'classnames/bind';
import { withFormatter } from '@concur/nui-intl-runtime';
import { withErrorBoundary, compose } from '@concur/core-ui-shell';
import Logo from '../Logo/Logo';
import styles from './AppMiniHeader.css';
import clearLocalizationMode from '../utils/clearLocalizationMode';

const CSS_BLOCK = 'sapcnqr-app-mini-header';

// Remove unused props in the future once all teams have upgraded to min version of
// nui-shell that stops passing these props + SU251 is in production
const MiniHeader = ({
    formatter,
    isGov,
    isRetiredBrand,
    isLoggedIn,
    isOpusUser,
    // eslint-disable-next-line no-unused-vars
    logoutUser,
}) => {
    const classnames = classnamesBind.bind(styles);

    const baseClasses = classnames(CSS_BLOCK);

    const homeIconClasses = classnames(
        `${CSS_BLOCK}__home-icon`,
        {
            [`${CSS_BLOCK}__home-icon--gov`]: isGov,
            [`${CSS_BLOCK}__home-icon--retired`]: isRetiredBrand,
        },
    );

    return (
        <div className={baseClasses}>
            <span>
                <Logo
                    styles={styles}
                    cssBlock={CSS_BLOCK}
                    className={homeIconClasses}
                    isGov={isGov}
                    isRetiredBrand={isRetiredBrand}
                    isOpusUser={isOpusUser}
                />
            </span>
            {isLoggedIn && (
                <Button
                    data-test="app-mini-header-signout-link"
                    onClick={() => {
                        clearLocalizationMode();
                        window.location.href = '/errors/loggedout.asp';
                    }}
                    type="link"
                    className={classnames(`${CSS_BLOCK}__button--signout`)}
                >
                    {formatter.formattedMessage({ id: 'CoreUI.signOut' })}
                </Button>
            )}
        </div>
    );
};

MiniHeader.displayName = 'MiniHeader';

MiniHeader.cssBlock = CSS_BLOCK;

MiniHeader.propTypes = {
    isLoggedIn: PropTypes.bool,
    isGov: PropTypes.bool,
    isRetiredBrand: PropTypes.bool,
    logoutUser: PropTypes.func,
    isOpusUser: PropTypes.bool,
};

export default compose(
    withFormatter,
    withErrorBoundary,
)(MiniHeader);
